(function ($) {
  Drupal.behaviors.beautiful_belle_parallax = {
    attach: function (context) {
      $('#belle_mod2', context).once(function () {
        var thisModuleName = 'belle_mod2';
        var triggerMod = '#belle_mod2';
        var $thismodule = $('#belle_mod2');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];

        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Check if Content Author has specified for module
        // to fade in.
        var moduleWillFade = false;
        var hasFaded = false;

        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // PARALLAX
        // Init scrollMagic Controller Class
        var parallaxController = new ScrollMagic.Controller();
        // Set the parallax duration
        var windowHeight = $(window).height();
        var parallaxDuration = windowHeight / 0.8;
        var $tweenElem = $thismodule.find('.js-belle_mod2__img-left');

        // Set the scene
        new ScrollMagic.Scene({
          triggerElement: triggerMod,
          offset: -20,
          duration: parallaxDuration
        })
          .setTween($tweenElem, 8, {
            marginTop: '-39%',
            ease: Linear.easeInOutQuad
          })
          .addTo(parallaxController);

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.

            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();
            var offset;

            // Set the offset.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });

            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
